/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
/**
* CSS Custom Properties
*
* These properties can be overridden using the component's tag as selector.
*
* @prop --calcite-table-header-background: Specifies the background color of the component.
* @prop --calcite-table-header-border-color: Specifies the border color of the component.
*/
:host {
  --calcite-internal-table-header-background: var(--calcite-table-header-background, var(--calcite-color-foreground-2));
  --calcite-internal-table-header-border-color: var(--calcite-table-border-color, var(--calcite-color-border-3));
  display: contents;
}

:host([alignment=center]) th {
  text-align: center;
}

:host([alignment=end]) th {
  text-align: end;
}

.assistive-text {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

th {
  white-space: normal;
  text-align: start;
  font-weight: var(--calcite-font-weight-medium);
  color: var(--calcite-color-text-1);
  font-size: var(--calcite-internal-table-cell-font-size);
  border-inline-end: 1px solid var(--calcite-internal-table-header-border-color);
  border-block-end: 1px solid var(--calcite-internal-table-header-border-color);
  padding-block: calc(var(--calcite-internal-table-cell-padding) * 1.5);
  padding-inline: var(--calcite-internal-table-cell-padding);
  background-color: var(--calcite-internal-table-header-background);
}
th:not(.static-cell) {
  outline-color: transparent;
}
th:not(.static-cell):not(.static-cell):focus-within {
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            -2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
}

th:not(.center):not(.end).content-cell {
  vertical-align: top;
}

th.center {
  vertical-align: middle;
}

th.end.content-cell {
  vertical-align: bottom;
}

th.body-row,
th.footer-row {
  padding-block: var(--calcite-internal-table-cell-padding);
  border-block-end: 0;
}

th.footer-row {
  border-block-start: 1px solid var(--calcite-internal-table-header-border-color);
}

th.last-cell {
  border-inline-end: 0;
}

.cell--multiple-selection {
  cursor: pointer;
  vertical-align: middle;
  color: var(--calcite-color-text-3);
}
.cell--multiple-selection:not(.end) {
  vertical-align: middle;
}

.selected-cell:not(.number-cell):not(.footer-cell) {
  --calcite-internal-table-header-background: var(--calcite-color-foreground-current);
}

.number-cell,
.selection-cell {
  color: var(--calcite-color-text-2);
  inline-size: 2rem;
  min-inline-size: 2rem;
}

.selection-cell calcite-icon.active {
  color: var(--calcite-color-brand);
}

.number-cell calcite-icon,
.selection-cell calcite-icon {
  margin-inline-start: auto;
  margin-inline-end: auto;
  vertical-align: middle;
}

.heading {
  color: var(--calcite-color-text-1);
}

.description {
  color: var(--calcite-color-text-3);
  font-size: var(--calcite-internal-table-cell-font-size-secondary);
}